const translations = {
    en: {
      home: "Home",
      programs: "Programs",
      aboutUs: "About Us",
      reasons: "Reasons",
      plans: "Pricing",
      login: "Login",
      logout: "Logout",
      profile: "Profile",
      settings: "Settings",
      getnow: "Get Now",
      overview: "Overview",
      requirements: "Requirements",
      videoList: "Video Lists",
      notifications: "Notification",
      subscribe: "Subscribe to a Plan",
      choose: "Choose a Plan",
      payment_method: "Select a Payment Method",
      scan: "Scan to Pay",
      checkout: "Checkout",
      order: "Order Summary",
      placeorder: "Place Order",
      process: "Processing...",
      upload: "Upload Your Payslip",
      cancel: "Cancel",
      hero_fig_1 : "EXPERT COACHES",
      hero_fig_2 : "members",
      hero_fig_3 : "workouts",
      hero_body : "In here we will help you to shape and build your ideal body and live up your life to fullest",
      why_one : "OVER 140+ EXPERT COACHES",
      why_two : "TRAIN SMARTER AND FASTER THAN BEFORE",
      why_three : "1 FREE PROGRAM FOR NEW MEMBER",
      why_four : "RELIABLE PAARTNERS",
      our_partner : "OUR PARTNERS",
      phone: "Phone Number",
      phone_placeholder: "Enter phone number used for payment",
      pendingTransactionTitle: "Transaction Pending",
      pendingTransactionMessage: "Your transaction is under review. Please wait for approval to unlock premium content."
    },
    mm: {
      home: "ပင်မစာမျက်နှာ",
      programs: "အစီအစဉ်များ",
      aboutUs: "ကျွန်ုပ်တို့အကြောင်း",
      reasons: "အကြောင်းပြချက်များ",
      plans: "စျေးနှုန်း",
      login: "အကောင့်ဝင်ရန်",
      logout: "အကောင့်ထွက်ရန်",
      profile: "သင့်ပရိုဖိုင်",
      settings: "ဆက်တင်များ",
      getnow: "ယခုရယူမည်",
      overview: "အနှစ်ချုပ်",
      requirements: "လိုအပ်ချက်များ",
      videoList: "ဗီဒီယိုများ",
      notifications: "အသိပေးချက်",
      subscribe: "အစီအစဉ်တစ်ခုကို စာရင်းသွင်းပါ",
      choose: "အစီအစဉ်တစ်ခုကို ရွေးချယ်ပါ",
      payment_method: "ငွေပေးချေမှုနည်းလမ်းတစ်ခုကို ရွေးချယ်ပါ",
      scan: "ငွေပေးချေရန် စကင်ဖတ်ပါ",
      checkout: "ငွေရှင်းလင်းရန်",
      order: "အော်ဒါအကျဉ်းချုပ်",
      placeorder: "အော်ဒါတင်သွင်းမည်",
      process: "လုပ်ဆောင်နေသည်...",
      upload: "သင့်ဘောင်ချာကို တင်ပါ",
      cancel: "ပယ်ဖျက်မည်",
      hero_fig_1 : "ကျွမ်းကျင်သော နည်းပြများ",
      hero_fig_2 : "အသင်းဝင်များ",
      hero_fig_3 : "လေ့ကျင့်ခန်းများ",
      hero_body : "ဒီမှာတော့ မင်းရဲ့ စိတ်ကြိုက်ကိုယ်ခန္ဓာကို ပုံဖော်ပြီး တည်ဆောက်ဖို့နဲ့ ဘဝကို အပြည့်အဝ ရှင်သန်နိုင်အောင် မင်းကို ကူညီပေးမယ်။",
      why_one : "ကျွမ်းကျင်သော နည်းပြပေါင်း ၁၄၀ ကျော်",
      why_two : "ယခင်ထက် ပိုမိုထိရောက်စွာ လေ့ကျင့်နိုင်",
      why_three : "Member အသစ်များအတွက် အခမဲ့အစီအစဉ်(၁)ခု",
      why_four : "ယုံကြည်စိတ်ချရသော လုပ်ဖော်ကိုင်ဖက်များ",
      our_partner : "လုပ်ဖော်ကိုင်ဖက်များ",
      phone: "ဖုန်းနံပါတ်",
      phone_placeholder: "ငွေပေးချေရာတွင် အသုံးပြုသော ဖုန်းနံပါတ် ရိုက်ထည့်ပါ",
      pendingTransactionTitle: "ငွေပေးချေမှု စောင့်ဆိုင်းနေရပါသည်",
      pendingTransactionMessage: "သင့်ငွေပေးချေမှုကို စစ်ဆေးနေပါသည်။ Premium အကြောင်းအရာများကို ဖွင့်ရန် အတည်ပြုချက်ကို စောင့်ပါ။"
    },
  };
  
  export default translations;
  